import { PropsWithChildren } from 'react';
import { StyledPrice, StyledPriceProps } from './styled';

type PriceProps = PropsWithChildren<StyledPriceProps>;

export const Price = ({ children, ...rest }: PriceProps) => <StyledPrice {...rest}>{children}</StyledPrice>;
